import React, { useEffect, useState } from 'react';
import { MapContainer, TileLayer, Marker, Popup, Polyline, useMap } from 'react-leaflet';
import L from 'leaflet';

// Fix default marker icons broken by webpack
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl:       require('leaflet/dist/images/marker-icon.png'),
  shadowUrl:     require('leaflet/dist/images/marker-shadow.png'),
});

const shadowUrl = require('leaflet/dist/images/marker-shadow.png');
const iconsBase = process.env.PUBLIC_URL + '/icons';

const greenIcon = new L.Icon({
  iconUrl: `${iconsBase}/marker-icon-2x-green.png`,
  shadowUrl,
  iconSize: [25, 41], iconAnchor: [12, 41], popupAnchor: [1, -34], shadowSize: [41, 41],
});

const orangeIcon = new L.Icon({
  iconUrl: `${iconsBase}/marker-icon-2x-orange.png`,
  shadowUrl,
  iconSize: [25, 41], iconAnchor: [12, 41], popupAnchor: [1, -34], shadowSize: [41, 41],
});

const carIcon = L.divIcon({
  html: '<div style="font-size:26px;line-height:1;filter:drop-shadow(0 2px 4px rgba(0,0,0,.5))">🚗</div>',
  className: '',
  iconSize: [32, 32],
  iconAnchor: [16, 16],
  popupAnchor: [0, -20],
});

function FitBounds({ from, to, driver }) {
  const map = useMap();
  useEffect(() => {
    if (from && to) {
      const points = [from, to];
      if (driver) points.push(driver);
      map.fitBounds(points, { padding: [50, 50] });
    } else if (from) {
      map.setView(from, 13);
    } else if (to) {
      map.setView(to, 13);
    }
  }, [from, to, driver, map]);
  return null;
}

export default function RideMap({ fromCoords, toCoords, fromLabel, toLabel, driverCoords }) {
  const defaultCenter = [48.8566, 2.3522];
  const [routePoints, setRoutePoints] = useState(null);

  useEffect(() => {
    if (!fromCoords || !toCoords) { setRoutePoints(null); return; }
    const [fromLat, fromLng] = fromCoords;
    const [toLat, toLng] = toCoords;
    fetch(`https://router.project-osrm.org/route/v1/driving/${fromLng},${fromLat};${toLng},${toLat}?overview=full&geometries=geojson`)
      .then((r) => r.json())
      .then((data) => {
        if (data.routes && data.routes[0]) {
          // OSRM returns [lng, lat], Leaflet needs [lat, lng]
          setRoutePoints(data.routes[0].geometry.coordinates.map(([lng, lat]) => [lat, lng]));
        } else {
          setRoutePoints([fromCoords, toCoords]);
        }
      })
      .catch(() => setRoutePoints([fromCoords, toCoords]));
  }, [fromCoords, toCoords]);

  return (
    <MapContainer
      center={fromCoords || toCoords || defaultCenter}
      zoom={12}
      className="w-full h-64 rounded-2xl z-0"
      scrollWheelZoom={false}
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      {fromCoords && (
        <Marker position={fromCoords} icon={greenIcon}>
          <Popup>{fromLabel || 'Pickup'}</Popup>
        </Marker>
      )}
      {toCoords && (
        <Marker position={toCoords} icon={orangeIcon}>
          <Popup>{toLabel || 'Drop-off'}</Popup>
        </Marker>
      )}
      {driverCoords && (
        <Marker position={driverCoords} icon={carIcon}>
          <Popup>Driver</Popup>
        </Marker>
      )}
      {routePoints && <Polyline positions={routePoints} color="#3b82f6" weight={4} opacity={0.7} />}
      <FitBounds from={fromCoords} to={toCoords} driver={driverCoords} />
    </MapContainer>
  );
}
